export default __webpack_public_path__ + "static/hk-c9b6afcab8fdd6bfd33aa1d048b1f3f3.webp";